module.exports = __webpack_public_path__ + "static/img/list02.46ea17b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Home/img/list02.jpg
// module id = 98XD
// module chunks = 1